import React from "react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_site-launch-253/artifacts/rjoafb6o_transparent%20voro%20logo.png";

export const VoroLogo = ({ className = "h-8 w-auto", withText = true, size }) => {
    const dim = size || className;
    return (
        <div className={`flex items-center gap-2.5 ${dim}`} data-testid="voro-logo">
            <img
                src={LOGO_URL}
                alt="Voro"
                draggable={false}
                className="h-full w-auto select-none"
                style={{
                    filter: "drop-shadow(0 6px 24px rgba(139,92,246,0.55))",
                }}
            />
            {withText && (
                <span
                    className="font-display text-[1.35rem] font-extrabold tracking-tight"
                    style={{
                        background: "linear-gradient(135deg, #c4b5fd 0%, #a855f7 50%, #7c3aed 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }}
                >
                    voro
                </span>
            )}
        </div>
    );
};

export default VoroLogo;
